import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { RaffleDealStoreCtx } from '@/stores/RaffleDealStore';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';

const RaffleDealApplyCompletePopup: React.FC = () => {
  const store = useContext(RaffleDealStoreCtx);
  const { isOpenSuccessPopup, popupProps } = store;

  return <Popup isOpen={isOpenSuccessPopup} {...popupProps} />;
};

export default observer(RaffleDealApplyCompletePopup);
